module.exports = __webpack_public_path__ + "img/JEEP-V.f7dde767.jpg";